import React from 'react';
import { Link } from 'react-router-dom'; // Import this at the top

import './FooterSection.css'; // You can create a separate CSS file for the consultation section

const ConsultationSection = () => {
  return (
    <section className="consultation-section container-fluid d-flex justify-content-center align-items-center py-5">
      <div className="consultation-box text-center p-4">
        <h2 className="mb-3">Take Charge of Your Breast Health Today!</h2>
        <p>Book a Infrared screening or speak to our specialists today.</p>
        {/* <button className="btn gradient-btn">Schedule a Consultation ➜</button> */}
        <button className="btn gradient-btn">
  <Link to="/contact#ConsultationForm" style={{ textDecoration: 'none', color: 'white' }}>
    Schedule a Consultation ➜
  </Link>
</button>
      </div>
    </section>
  );
};

export default ConsultationSection;
